// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phases-create-edit-fair-play-settings-modal .modal2__container {
    width: 70%;
}

.phases-create-edit-fair-play-settings-modal .form {
    padding: 36px 52px 12px 52px;
}

.phases-create-edit-fair-play-settings-modal .form .input-field-input {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 16px;
    text-align: center;
}

.phases-create-edit-fair-play-settings-modal .form .input-field-label {
    color: var(--primary-very-dark-color);
    font-size: calc(var(--space) - 1px);
    font-weight: var(--font-regular);
}

.phases-create-edit-fair-play-settings-modal .form .phases-create-edit-fair-play-settings-modal__row .input-field-input {
    text-align: left;
}

.phases-create-edit-fair-play-settings-modal__row .input-field{
    max-width: 40%;
    margin-bottom: 0;
    margin-top: 20px;
}

.phases-create-edit-fair-play-settings-modal__columns {
    display: flex;
    align-items: flex-start;
    gap: 44px;
    margin-top: 24px;
}

.phases-create-edit-fair-play-settings-modal__columns.high-top-margin{
    margin-top: 44px;
}

.phases-create-edit-fair-play-settings-modal__columns .input-field{
    margin-top: 40px;
    margin-bottom: 0;
}

.phases-create-edit-fair-play-settings-modal__columns .input-field.long_label {
    min-width: 180px;
}

.phases-create-edit-fair-play-settings-modal__columns .input-field-input {
    max-width: 80px;
}

.phases-create-edit-fair-play-settings-modal__columns .input-field__message {
    margin-left: 0;
}

.phases-create-edit-fair-play-settings-modal__columns__column{
    width: 50%;
}

.phases-create-edit-fair-play-settings-modal__columns__column .baloa-names {
    color: var(--primary-very-dark-color);
}

.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column {
    font-weight: var(--font-regular);
    margin-top: 8px;
    color: var(--primary-dark-color);
}

.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column.infolbl {
    color: var(--primary-very-dark-color);
    margin-top: 16px;
    display: flex;
    align-items: center;
}

.phases-create-edit-fair-play-settings-modal__columns__column .hubicon-info_v2 {
    font-size: 20px;
    color: var(--new-informative-banner-color);
    margin-right: 4px;
}

.phases-create-edit-fair-play-settings-modal__columns__column__row-items {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
}

.phases-create-edit-fair-play-settings-modal__columns__column__row-items .input-field {
    margin-right: 52px;
}

.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column.label {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.phases-create-edit-fair-play-settings-modal__radio-options .MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {
    color: var(--primary-very-dark-color);
}

.phases-create-edit-fair-play-settings-modal__radio-options .MuiTypography-root {
    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */
}

.phases-create-edit-fair-play-settings-modal__buttons {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 12px 16px;
}

.phases-create-edit-fair-play-settings-modal__buttons .button {
    margin-left: auto;
    padding: 10px 24px;
}

.phases-create-edit-fair-play-settings-modal__cards-points {
    margin-top: 8px;
}

.phases-create-edit-fair-play-settings-modal__cards-points .baloa-table-column {
    margin-bottom: 12px;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card.start-row{
    margin-top: 12px;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card img {
    margin-right: 4px;
    width: 15px;
    height: 20px;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card .input-field {
    margin-top: 0;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card .input-field-input {
    max-width: 56px;
    margin-right: 12px;
    padding: var(--space) 16px;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card input.input-field-input::-webkit-outer-spin-button,
.phases-create-edit-fair-play-settings-modal__cards-points__card input.input-field-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Hide spin buttons in Firefox */
.phases-create-edit-fair-play-settings-modal__cards-points__card input[type="number"] {
    -moz-appearance: textfield;
}

.phases-create-edit-fair-play-settings-modal__cards-points__card .baloa-table-column.label {
    margin-top: 0;
    margin-right: 12px;
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-create-edit-fair-play-settings-modal/TournamentPhasesCreateEditFairPlaySettingsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sEAAsE,CAAC,SAAS;AACpF;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".phases-create-edit-fair-play-settings-modal .modal2__container {\n    width: 70%;\n}\n\n.phases-create-edit-fair-play-settings-modal .form {\n    padding: 36px 52px 12px 52px;\n}\n\n.phases-create-edit-fair-play-settings-modal .form .input-field-input {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 16px;\n    text-align: center;\n}\n\n.phases-create-edit-fair-play-settings-modal .form .input-field-label {\n    color: var(--primary-very-dark-color);\n    font-size: calc(var(--space) - 1px);\n    font-weight: var(--font-regular);\n}\n\n.phases-create-edit-fair-play-settings-modal .form .phases-create-edit-fair-play-settings-modal__row .input-field-input {\n    text-align: left;\n}\n\n.phases-create-edit-fair-play-settings-modal__row .input-field{\n    max-width: 40%;\n    margin-bottom: 0;\n    margin-top: 20px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns {\n    display: flex;\n    align-items: flex-start;\n    gap: 44px;\n    margin-top: 24px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns.high-top-margin{\n    margin-top: 44px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns .input-field{\n    margin-top: 40px;\n    margin-bottom: 0;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns .input-field.long_label {\n    min-width: 180px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns .input-field-input {\n    max-width: 80px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns .input-field__message {\n    margin-left: 0;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column{\n    width: 50%;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column {\n    font-weight: var(--font-regular);\n    margin-top: 8px;\n    color: var(--primary-dark-color);\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column.infolbl {\n    color: var(--primary-very-dark-color);\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column .hubicon-info_v2 {\n    font-size: 20px;\n    color: var(--new-informative-banner-color);\n    margin-right: 4px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column__row-items {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 4px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column__row-items .input-field {\n    margin-right: 52px;\n}\n\n.phases-create-edit-fair-play-settings-modal__columns__column .baloa-table-column.label {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.phases-create-edit-fair-play-settings-modal__radio-options .MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-create-edit-fair-play-settings-modal__radio-options .MuiTypography-root {\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */\n}\n\n.phases-create-edit-fair-play-settings-modal__buttons {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 12px 16px;\n}\n\n.phases-create-edit-fair-play-settings-modal__buttons .button {\n    margin-left: auto;\n    padding: 10px 24px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points {\n    margin-top: 8px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points .baloa-table-column {\n    margin-bottom: 12px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card.start-row{\n    margin-top: 12px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card img {\n    margin-right: 4px;\n    width: 15px;\n    height: 20px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card .input-field {\n    margin-top: 0;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card .input-field-input {\n    max-width: 56px;\n    margin-right: 12px;\n    padding: var(--space) 16px;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card input.input-field-input::-webkit-outer-spin-button,\n.phases-create-edit-fair-play-settings-modal__cards-points__card input.input-field-input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Hide spin buttons in Firefox */\n.phases-create-edit-fair-play-settings-modal__cards-points__card input[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.phases-create-edit-fair-play-settings-modal__cards-points__card .baloa-table-column.label {\n    margin-top: 0;\n    margin-right: 12px;\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
